import { render, staticRenderFns } from "./AuthGroup.vue?vue&type=template&id=483b8f0d&scoped=true"
import script from "./AuthGroup.vue?vue&type=script&lang=js"
export * from "./AuthGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b8f0d",
  null
  
)

export default component.exports